
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <ul>
      <li parentName="ul">{`This project uses `}<a parentName="li" {...{
          "href": "http://www.atlassian.com/software/jira"
        }}>{`JIRA`}</a>{` a J2EE-based, issue tracking and project management application.`}</li>
    </ul>
    <h1 {...{
      "id": "issue-tracking"
    }}>{`Issue Tracking`}</h1>
    <p>{`Issues, bugs, and feature requests should be submitted to the following issue tracking system for this project.
`}<a parentName="p" {...{
        "href": "https://issues.apache.org/jira/browse/ATLAS"
      }}>{`https://issues.apache.org/jira/browse/ATLAS`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;